// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Github = function Github(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M8 1a7.09 7.09 0 00-7 7.18A7.16 7.16 0 005.79 15c.35.06.48-.16.48-.34v-1.34c-1.76.33-2.21-.44-2.35-.84a2.7 2.7 0 00-.72-1c-.25-.13-.6-.46 0-.47a1.43 1.43 0 011.08.73 1.46 1.46 0 002 .59 1.6 1.6 0 01.45-1c-1.56-.18-3.19-.79-3.19-3.54a2.86 2.86 0 01.72-1.93A2.66 2.66 0 014.34 4s.59-.19 1.93.74a6.25 6.25 0 013.5 0c1.34-.97 1.92-.74 1.92-.74a2.6 2.6 0 01.07 1.9 2.8 2.8 0 01.72 1.93c0 2.75-1.64 3.36-3.19 3.54a1.76 1.76 0 01.47 1.33v2a.35.35 0 00.48.34A7.18 7.18 0 0015 8.18 7.09 7.09 0 008 1z"
    }))
  );
};

export default Github;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Github.js
// module id = 1017
// module chunks = 0